<div class="responsive-container p-grid">
  <p-panel>
    <ng-template pTemplate="header">
      <div class="responsive-header">
        <div>
          <span class="responsive-header-title">
            Escaneo de Palet
          </span>
        </div>

        <div class="flex gap-2 align-items-center">
          <button pButton icon="pi pi-times" class="p-button-rounded p-button-text"
          (click)="onClose()"></button>
        </div>
      </div>
    </ng-template>

  <p-fluid>
    <div class="content">
      <!-- View Messages -->
      <p-toast [breakpoints]="{ '920px': { width: '100%', right: '0', left: '0' } }" />

      <!-- Manual Palet Scanner -->
      @if (!qrCode) {
        <div class="field">
          <label for="manualQr">Código Etiqueta de Palet</label>
          <input id="manualCode" type="text" pInputText placeholder="Escanea el Código QR"
            [(ngModel)]="manualPaletQrCode" (input)="onManualPalletInputChange()" />
        </div>
      }

      @if (qrCode) {
        <div class="field">
          <p-chip [label]="qrCode" icon="" (onRemove)="resetQr()"
            [removable]="true"><strong>Código:</strong></p-chip>
          </div>
        }

        <form [formGroup]="palletForm">
          <div class="field">
            <label for="pallet_length">Largo <span class="req">*</span></label>
            <p-inputNumber formControlName="depth" id="pallet_length" inputId="minmax" mode="decimal" [min]="1"
              [max]="5000" suffix=" cm" placeholder="centimetros" required>
            </p-inputNumber>
            @if (submitted && (formControl['depth'].errors?.['required'] || formControl['depth'].errors?.['whitespace'] || formControl['depth'].errors?.['minlength'])) {
              <small class="p-error"
                >Largo
              es requerido.</small>
            }
          </div>

          <div class="field">
            <label for="pallet_width">Ancho <span class="req">*</span></label>
            <p-inputNumber formControlName="width" id="pallet_width" inputId="minmax" mode="decimal" [min]="1"
              [max]="5000" [fluid]="true" [style]="{'width':'100%'}" suffix=" cm" placeholder="centimetros" required>
            </p-inputNumber>
            @if (submitted && (formControl['width'].errors?.['required'] || formControl['width'].errors?.['whitespace'] || formControl['width'].errors?.['minlength'])) {
              <small class="p-error"
                >Ancho
              es requerido.</small>
            }
          </div>

          <div class="field">
            <label for="pallet_height">Alto <span class="req">*</span></label>
            <p-inputNumber formControlName="height" id="pallet_height" inputId="minmax" mode="decimal" [min]="1"
              [max]="5000" [fluid]="true" [style]="{'width':'100%'}" suffix=" cm" placeholder="centimetros" required>
            </p-inputNumber>
            @if (submitted && (formControl['height'].errors?.['required'] || formControl['height'].errors?.['whitespace'] || formControl['height'].errors?.['minlength'])) {
              <small class="p-error"
                >Alto
              es requerido.</small>
            }
          </div>

          <div class="field">
            <label for="adress_notes">Notas</label>
            <textarea formControlName="notes" id="adress_notes" rows="3" cols="30" pInputTextarea
            maxlength="200"></textarea>
          </div>

          <div class="field">
            <p-button (click)="openCamera()" label="Tomar foto de Palet" icon="pi pi-camera" [rounded]="true"
              severity="info" [outlined]="true" />
            <input type="file" id="cameraInput" accept="image/*" capture="environment"
              (change)="onPhotoSelected($event)" style="display:none;" multiple>
          </div>

          <div class="field">
            @if (selectedImages.length > 0) {
              @for (image of selectedImages; track image; let i = $index) {
                <p-chip [label]="'Foto ' + (i+1)"
                  removable="true" (onRemove)="removeImage(i)" class="p-chip mb-1 ml-1"
                  styleClass="padding: 0 0.50rem;">
                  <img [src]="image" alt="Foto" style="width: 30px; height: 30px; margin-left: 2px;" />
                </p-chip>
              }
            }
          </div>

          <div class="field">
            <label for="flooring">Nivel</label>
            <p-select formControlName="flooring" id="flooring" appendTo="body" [(ngModel)]="flooring"
            [options]="floorings" placeholder="Nivel"></p-select>
          </div>
          <div class="field">
            <label for="location">Locación</label>
            <input formControlName="location" type="text" pInputText id="location" class="w-full"
              placeholder="Locación" />
          </div>

          <div class="field">
            <p-button label="Guardar Palet" icon="pi pi-save" (click)="onSave()"
            [disabled]="!qrCode"></p-button>
          </div>

        </form>
      </div>
    </p-fluid>
    </p-panel>
  </div>
  <p-confirmDialog></p-confirmDialog>